import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-9544">
      <PaymentForm data-id="element-9545" />
    </div>;
}